import {
  backend,
  BackendQueryKeys,
  ContractSection,
  useTypeSafeQuery,
} from '@oresundsbron/api';
import { NavisionContractType } from '@oresundsbron/validators';
import { map } from 'fp-ts/lib/Array';
import { pipe } from 'fp-ts/lib/function';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { setMainContract, useContractsStore } from '../stores/contracts';

export function useContracts(
  section: ContractSection,
  contract: NavisionContractType
) {
  const { contracts, main } = useContractsStore();
  const { locale } = useRouter();
  const { data } = useTypeSafeQuery(
    BackendQueryKeys.ContractTypeList({ type: section, locale }),
    (req) =>
      req.Contract.contractTypeList({ type: section, locale: locale || '' })
  );

  useEffect(() => {
    if (!data) {
      return;
    }

    const c = data.filter((c) => c.value === contract);

    if (!c.length) {
      return;
    }

    const [head] = c;

    setMainContract({
      ...head,
      prices: pipe(
        c,
        map(({ currency, price, priceInclVat }) => ({
          currency,
          price,
          priceInclVat,
        }))
      ),
    });
  }, [data, contract]);

  return { contracts, main };
}
